// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3296b3c","455":"76b1eec9","977":"475f3977"}[chunkId] + ".chunk.js";
};